export default __webpack_public_path__ + "static/media/active-index.7d8f6385.png";